module.exports = __webpack_public_path__ + "media/30 adorn sth. sb. with sth.48949aa2.mp3";